export const pagesProductionEn = {
  detail: {
    basicInfo: {
      fields: {
        createdAt: 'Created At',
        description: 'Description',
        plannedReleaseDate: 'Planned Release Date',
        product: 'Product',
        productionCode: 'Production',
        release: 'Release',
        releaseLevel: 'Release Level',
        releasedAt: 'Released At',
        status: 'Status',
        updatedAt: 'Updated At'
      },
      title: 'Basic Information'
    },
    breadcrumb: {
      home: 'Home',
      productions: 'Productions'
    },
    devScopeEdit: {
      addDialog: {
        addButton: 'Add',
        candidateMeta: '{{product}} / {{priority}}',
        empty: 'No assignable tickets',
        sameProductBadge: 'Same product',
        searchPlaceholder: 'Search by title or code',
        title: 'Add tickets'
      },
      addTickets: '+ Add tickets',
      changeButton: 'Change Dev Tickets',
      currentTickets: {
        columns: {
          code: 'Code',
          kind: 'Kind',
          priority: 'Priority',
          product: 'Product',
          status: 'Status',
          title: 'Title'
        },
        empty: 'No tickets in this dev scope',
        remove: 'Remove'
      },
      done: 'Done',
      pageTitle: 'Edit Dev Scope',
      stepSelectTickets: 'Select tickets',
      toast: {
        addError: 'Failed to add tickets',
        addSuccess: 'Added {{count}} ticket(s) to the dev scope',
        removeError: 'Failed to remove the ticket',
        removeSuccess: 'Removed the ticket from the dev scope'
      }
    },
    header: {
      panels: {
        daysRemaining: {
          hoursSuffix: '{{hours}} hours',
          label: 'Days Remaining',
          released: 'Released',
          remainingBadge: '{{days}} days left',
          unit: '{{days}} days',
          unset: 'Not set'
        },
        plannedReleaseDate: {
          label: 'Planned Release Date',
          unset: 'Not set'
        },
        version: {
          label: 'Release Version'
        }
      }
    },
    issueScopeEdit: {
      addDialog: {
        addButton: 'Add',
        empty: 'No assignable issues',
        sameProductBadge: 'Same product',
        searchPlaceholder: 'Search by title',
        title: 'Add issues'
      },
      addIssues: '+ Add issues',
      changeButton: 'Change Issues',
      currentIssues: {
        columns: {
          priority: 'Priority',
          severity: 'Severity',
          status: 'Status',
          title: 'Title'
        },
        empty: 'No issues in this scope',
        remove: 'Remove'
      },
      done: 'Done',
      pageTitle: 'Edit Issue Scope',
      stepSelectIssues: 'Select issues',
      toast: {
        addError: 'Failed to add issues',
        addSuccess: 'Added {{count}} issue(s) to the scope',
        removeError: 'Failed to remove the issue',
        removeSuccess: 'Removed the issue from the scope'
      }
    },
    options: {
      productionStatus: {
        APPROVED: 'Approved',
        IN_PROGRESS: 'In Progress',
        PLANNED: 'Planned',
        RELEASED: 'Released'
      },
      releaseLevel: {
        HOTFIX: 'Hotfix',
        MAJOR: 'Major',
        MINOR: 'Minor',
        PATCH: 'Patch',
        REVISION: 'Revision'
      }
    },
    pageTitle: 'Production Detail',
    productScope: {
      noResults: 'No nodes are scoped for this release.',
      table: {
        category: {
          isBugfix: 'Bugfix',
          isNew: 'New',
          isUpdated: 'Updated'
        },
        headers: {
          category: 'Category',
          kind: 'Type',
          name: 'Name',
          nodeVersion: 'Version',
          owner: 'Owner',
          priority: 'Priority',
          publishStatus: 'Status',
          updatedAt: 'Updated At'
        },
        kind: {
          FUNCTION: 'Function',
          MODULE: 'Module',
          PRODUCT: 'Product',
          SUB_MODULE: 'Sub Module'
        },
        priority: {
          P0: 'Critical',
          P1: 'High',
          P2: 'Medium',
          P3: 'Low'
        }
      }
    },
    scope: {
      summary: {
        issueCount: 'Issues',
        testSuiteCount: 'Test Suites',
        ticketCount: 'Tickets'
      },
      testSuites: {
        empty: 'No test suites',
        title: 'Test Suites'
      },
      tickets: {
        empty: 'No tickets',
        title: 'Tickets'
      },
      title: 'Scope'
    },
    sidebar: {
      basicInfo: 'Basic Information',
      scope: 'Scope'
    },
    tabs: {
      devScope: 'Dev Tickets',
      document: 'Documents',
      history: 'History',
      issueScope: 'Issues',
      overview: 'Overview',
      productScope: 'Product Scope',
      qualityScope: 'Test Sets',
      value: 'Value'
    },
    value: {
      noResults: 'No values are linked to this release.',
      table: {
        headers: {
          code: 'No.',
          layer: 'Layer',
          reporter: 'Reporter',
          status: 'Status',
          targetBusiness: 'Business',
          targetUser: 'User',
          title: 'Title',
          updatedAt: 'Updated At'
        },
        layer: {
          COMPANY_WIDE: 'Company-wide',
          EXECUTIVE: 'Executive',
          MANAGER: 'Manager',
          OPERATOR: 'Operator'
        },
        status: {
          HYPOTHESIS: 'Value Hypothesis (Unverified)',
          HYPOTHESIS_VERIFIED: 'Value Hypothesis (Verified)',
          PROMISE: 'Promise',
          SEED: 'Seed'
        }
      }
    },
    valueScopeEdit: {
      addDialog: {
        addButton: 'Add',
        empty: 'No assignable values',
        searchPlaceholder: 'Search by title or code',
        title: 'Add values'
      },
      addValues: '+ Add values',
      changeButton: 'Change Values',
      currentValues: {
        columns: {
          code: 'Code',
          layer: 'Layer',
          status: 'Status',
          targetBusiness: 'Business',
          targetUser: 'User',
          title: 'Title'
        },
        empty: 'No values in this scope',
        remove: 'Remove'
      },
      done: 'Done',
      layer: {
        COMPANY_WIDE: 'Company-wide',
        EXECUTIVE: 'Executive',
        MANAGER: 'Manager',
        OPERATOR: 'Operator'
      },
      pageTitle: 'Edit Value Scope',
      stepSelectValues: 'Select values',
      toast: {
        addError: 'Failed to add values',
        addSuccess: 'Added {{count}} value(s) to the scope',
        removeError: 'Failed to remove the value',
        removeSuccess: 'Removed the value from the scope'
      }
    }
  },
  list: {
    columns: {
      description: 'Description',
      plannedReleaseDate: 'Planned Release',
      productName: 'Product',
      releaseLevel: 'Level',
      releaseName: 'Version',
      releasedAt: 'Released At',
      status: 'Status',
      testSuiteCount: 'Test Suites',
      ticketCount: 'Tickets'
    },
    filterPlaceholder: 'Search productions...',
    filters: {
      level: 'Level'
    },
    noResults: 'No productions found.',
    pageTitle: 'Productions',
    searchPlaceholder: 'Search by name...',
    statusTabs: {
      ALL: 'All',
      APPROVED: 'Approved',
      IN_PROGRESS: 'In Progress',
      PLANNED: 'Planned',
      RELEASED: 'Released'
    },
    tabLabel: 'Production List'
  },
  title: 'Productions'
};